import ClipboardJS from "clipboard/dist/clipboard.min.js"

new ClipboardJS('.clipboardable');
